module.exports = __webpack_public_path__ + "media/images/ic-jp-tech-shield-9d7b5f02d15b3aa7634982393eb4350c.svg";